import React from 'react'
import { ADMIN_NAV_TITLE, DASHBOARD_NAV_TITLE } from 'utils/product/navTitles'

export const ADMIN_TITLE = ADMIN_NAV_TITLE
export const DASHBOARD_TITLE = DASHBOARD_NAV_TITLE
export const ACCESSIBILITY_TITLE = DASHBOARD_NAV_TITLE

export const WEBINARS_TITLE = (
  <span>
    Second Step<sup>®</sup> Implementation Webinars
  </span>
)

export const DISTRICT_TITLE = 'District Supports'
export const FAMILY_RESOURCES_ELEMENTARY_TITLE =
  'Family Resources for Elementary'
export const FAMILY_RESOURCES_MIDDLE_SCHOOL_TITLE =
  'Family Resources for Middle School'
export const MIND_YETI_FAMILY = 'Mind Yeti® Sessions'
export const K8_REPORTS_TITLE = 'Lesson Completion Report'
export const SELA_REPORTS_TITLE = 'SEL for Adults Program Report'
export const SETUP_ADMIN = 'Set-Up Admin'
export const RESOURCE_LIBRARY_TITLE = 'Resource Library'
